import { INonStandard } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer, ITransformContext } from "./IJsonTransformer";

export class RemoveNonstandardTemplateTransformer extends BaseJsonTransformer {

    constructor() {
        super();
    }

    override async transformNonStandard(nonStandard: INonStandard, context: ITransformContext): Promise<boolean | void> {
        nonStandard.partOfTemplate = false;
    }
 
}
